// must be in sync with com.atlassian.jira.web.filters.frontend.ConnectGeneralPagesFrontendRoute::matchesRequest
export const CONNECT_GENERAL_QUERY_PARAMS = [
	'mobile?!=true',
	'includeWebResources?!=true',
	'classifier?!=json',
	'project.key?',
	'project.id?',
];
